import { useRouteMatch } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ExamContents } from './exam';
import useAxios from '../../../hooks/useAxios';
import { IGetSpeaking } from '../../../models/newSpeaking.model';
import { getSpeaking } from '../../../api/newSpeaking.api';
import Instruction from '../../../components/cbt/speaking-test/Instruction';
import Loader from '../../../components/Loader';
import ErrorResponse from '../../../components/ErrorResponse';
import Evaluation from '../../../components/cbt/speaking-test/Evaluation';
import NewWindowLayout from '../../../components/layout/NewWindowLayout';

interface IMatch {
  speakingExamCode: string;
};

const CbtSpeakingTestPreview = () => {
  const match = useRouteMatch<IMatch>();
  const speakingExamCode = Number(match.params.speakingExamCode);
  const { data: res, isLoading, error, execute } = useAxios<IGetSpeaking>();

  const [content, setContent] = useState<ExamContents>(ExamContents.Instruction);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    execute(getSpeaking(speakingExamCode));
  }, []);

  const onFinish = () => {
    if ((res?.data?.papers?.length || 0) <= index + 1) {
      window.close();
    } else {
      setIndex(index + 1);
    }
  };

  const renderContent = () => {
    if (res) {
      switch (content) {
        case ExamContents.Instruction:
          return (
            <Instruction
              data={res?.data}
              onNext={() => setContent(ExamContents.Evaluation)}
            />
          );
        case ExamContents.Evaluation:
          return (
            <Evaluation data={res?.data} index={index} onFinish={onFinish} />
          );
      }
    }
  };

  return (
    <NewWindowLayout title="Speaking Test">
      {isLoading && <Loader />}
      <ErrorResponse error={error} />
      {renderContent()}
    </NewWindowLayout>
  );
};

export default CbtSpeakingTestPreview;